<template>
    <div class="form-group row centix-vue-textinput" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
        <form-label :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
        <span class="holder-span" :class="inputCssClass">
          <input
            ref="input"
            :type="type"
            autocomplete="off"
            class="form-control input-item"
            v-bind:class="{ filled_no_padding : hasValueWithoutPadding, filled : hasValueWithPadding, required : showRequiredClass }"
            v-model="innervalue"
            v-on:input="onChange"
            @blur="onblur"
            @focus="onfocus"
            v-on:keyup.esc="$event.target.blur()"
            v-on:keypress="onKeyPress"
            v-on:keyup.enter="onReturn"
						v-on:keyup.115="onF4()"
            v-bind:placeholder="placeholder"
            v-bind:disabled="!isEnabled"
            v-bind:maxlength="maxlength">

          <span class="buttons">
            <span v-if="showExpand" class="expand-button" @click="() => advancedSearchOpen = true" :title="$t('formtextareainput.expand')">
              <icon-base
                :view-box="'0 0 32 32'"
                :width="22"
                :height="22"
                :icon-color="'#999'">
                <expand />
              </icon-base>
            </span>
          </span>
        </span>
        <div class="model-state-error col-12">
          {{ validationError }}
        </div>
        <portal to="bottomPage">
          <!-- New FormTextAreaInput with same form properties in modal with overridden style -->
          <modal-comp v-if="advancedSearchOpen" :show-modal="advancedSearchOpen" :closeCallback="() => advancedSearchOpen = false">
            <div class="container rounded pb-2" style="background: white;">
              <component 
                v-bind="mappedProps"
                v-model="innervalue"
                :custom-style="'min-height: 80vh'"
                :is="advancedSearchComponent"
                :show-expand="false"
                @change="onChange" />
            </div>
        </modal-comp>
      </portal>
    </div>
</template>
<script>
import FormMixin from './formitem.js';
import IconBase from '@/components/IconBase.vue';
import ModalComponent from '@/pages/app/MI/components/Modal.vue';

const Expand = {
  template: `<path d="M11.797 16.5a.54.54 0 01-.156.359l-5.187 5.187 2.25 2.25a.996.996 0 01.297.703c0 .547-.453 1-1 1h-7c-.547 0-1-.453-1-1v-7c0-.547.453-1 1-1a.99.99 0 01.703.297l2.25 2.25 5.187-5.187c.094-.094.234-.156.359-.156s.266.063.359.156l1.781 1.781a.536.536 0 01.156.359zM24 3v7c0 .547-.453 1-1 1a.99.99 0 01-.703-.297l-2.25-2.25-5.187 5.187c-.094.094-.234.156-.359.156s-.266-.063-.359-.156l-1.781-1.781c-.094-.094-.156-.234-.156-.359s.063-.266.156-.359l5.187-5.187-2.25-2.25a.996.996 0 01-.297-.703c0-.547.453-1 1-1h7c.547 0 1 .453 1 1z"/>`
};
const getFormTextAreaInput = () => import('./FormTextAreaInput.vue');

export default {
  mixins: [FormMixin],
  props: {
    maxlength: Number,
    type: {
      type: String,
      default: 'text'
    },
    onlyNumbers : {
      type: Boolean,
      default: false
    },
    showExpand: {
      type: Boolean,
      default: false
    },
    showPaddingWhenFilled: {
      type: Boolean,
      default: true
    }
  },
    components: {
    'icon-base': IconBase,
    'expand': Expand,
    'modal-comp': ModalComponent
  },
  data () {
    return {
      advancedSearchOpen: false,
      advancedSearchComponent: getFormTextAreaInput,
      formType: 'text',
      innervalue: '',
      results: [],
      selectedIndex: 0,
      hasFocus: false,
      selectedItem: null,
      isBusy: false,
      hasError: false,
      lastError: ''
    };
  },
  mounted () {
    this.innervalue = this.value;
  },
  methods: {
    clearForm: function () {
      this.$emit('change', '');
      this.emitFormChange();
    },
    onChange: function (e) {
      this.$emit('change', this.innervalue);
      this.emitFormChange();
    },
    onblur: function () {
      this.$emit('blur', '');
    },
    onfocus: function () {
      this.$emit('focus');
    },
		onF4: function (e) {
			this.$emit('on-advanced-search', this.innervalue);
		},
    onKeyPress (e) {
      if (this.onlyNumbers) {
        const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        
        if (!keysAllowed.includes(e.key)) {
          e.preventDefault();
        }
      }
    }
  },
  watch: {
    value () {
      this.innervalue = this.value;
    }
  },
  computed: {
    hasValue: function () {
      return this.innervalue != null && this.innervalue.length > 0;
    },
    hasValueWithoutPadding: function () {
      return this.hasValue === true && this.showPaddingWhenFilled === false;
    },
    hasValueWithPadding: function () {
      return this.hasValue === true && this.showPaddingWhenFilled === true;
    },
    mappedProps () {
      let copy = { ...this.$props };
      delete copy.value;
      copy.noWrappers = false;
      copy.overrideLabelCss = null;
      copy.orientation = 'vertical';
      return copy;
    },
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';
.buttons {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    .user-comment-button, .expand-button {
      cursor: pointer;
    }
  }
.centix-vue-textinput {
  span.holder-span {
    position: relative;
    display: block;
    width: 100%;
  }
  &:hover {
    .clear-button {
      display: block;
    }
  }
  .clear-button {
    position: absolute;
    right: 15px;
    top: 0;
    background: url('../../assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 50px;
    height: 100%;
    cursor: pointer;
    display: none;
  }
  &:not(.disabled) {
  .input-item {
      &.required {
        border: 1px solid red;
      }
      &.filled {
        padding-right: 25px;
        border: 1px solid #80bdff;
      }
      &.filled_no_padding {
        border: 1px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
</style>
